const clientId =
  process.env.NODE_ENV === 'production'
    ? 'c9c3e880-51a8-4bf3-8f36-8639085d9ecd'
    : process.env.VUE_APP_CLIENT_ID
const authority =
  process.env.NODE_ENV === 'production'
    ? 'https://login.microsoftonline.com/9e16780e-719d-496b-a880-24ac20c30a60/'
    : process.env.VUE_APP_AUTHORITY
const environment =
  process.env.NODE_ENV === 'production'
    ? 'prod'
    : process.env.ELASTIC_APM_ENVIRONMENT
const serviceVersion =
  process.env.NODE_ENV === 'production'
    ? '1.1.0'
    : process.env.ELASTIC_APM_SERVICE_VERSION
module.exports = {
  clientId: clientId,
  authority: authority,
  environment: environment,
  serviceVersion: serviceVersion
}
